import { EmployeeSummaryDto } from './employee-summary-dto.model';


export class EmployeeAdditionalSalaryDto implements IEmployeeAdditionalSalaryDto {
    id!: number;
    employee!: EmployeeSummaryDto;
    month!: Date | undefined;
    additionalAmount!: number;

    constructor(data?: IEmployeeAdditionalSalaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.month = _data["month"] ? new Date(_data["month"].toString()) : <any>undefined;
            this.additionalAmount = _data["additionalAmount"];
        }
    }

    static fromJS(data: any): EmployeeAdditionalSalaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeAdditionalSalaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["month"] = this.month ? this.month.toISOString() : <any>undefined;
        data["additionalAmount"] = this.additionalAmount;
        return data; 
    }
}

export interface IEmployeeAdditionalSalaryDto {
    id: number;
    employee: EmployeeSummaryDto;
    month: Date | undefined;
    additionalAmount: number;
}

